export default preloadedState =>
  reducerMap =>
  (state = preloadedState, action) => {
    const reducer = reducerMap[action.type]
    return reducer ? reducer(state, action) : state
  }
